import { render, staticRenderFns } from "./ConfirmNavigationDialog.vue?vue&type=template&id=c167c2f6&scoped=true"
import script from "./ConfirmNavigationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmNavigationDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmNavigationDialog.vue?vue&type=style&index=0&id=c167c2f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c167c2f6",
  null
  
)

export default component.exports